import React, { useRef, useState } from "react";
import { Button } from "components";
import { useThemesContext } from "../../../../builder/context/ThemeProvider";
import { useOnClickOutside } from "components/hooks";
import { DotsIcon, RenameIcon } from "../../../icons";
import ChangelogModal from "./changelog";
import ThemeIcon from "../themes/cards/icon.svg";

import "./index.scss";

const StoreCard = ({ setCurrentSchema, category, changelogs, version, schema, preview_url, name }) => {

    const { createTheme } = useThemesContext();

    const dropdownRef = useRef();
    const [showChangelog, setChangelog] = useState(false);
    const [buttonDropdown, setButtonDropdown] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);

    const closeDropdownMenu = () => setButtonDropdown(false);
    const toggleDropdownMenu = () => setButtonDropdown(!buttonDropdown);

    useOnClickOutside(dropdownRef, closeDropdownMenu);

    const handleChangelogClick = () => {
        setChangelog(true);
    }

    const handleImageError = () => {
        setImageError(true);
        setImageLoaded(false);
    }

    const handleImageLoad = () => {
        setImageLoaded(true);
        setImageError(false);
    }

    // Use schema as fallback if name is null or empty, and capitalize it
    const displayName = name || (schema && schema.charAt(0).toUpperCase() + schema.slice(1)) || 'Unnamed Theme';

    return <div className="store-card">

        {showChangelog && <ChangelogModal isOpen={showChangelog} changelogs={changelogs} onClose={() => setChangelog(false)} />}

        <div className="store-card-image">
            {!imageError && preview_url ? (
                <img 
                    src={preview_url} 
                    alt={displayName}
                    onError={handleImageError}
                    onLoad={handleImageLoad}
                    style={{ display: imageLoaded ? 'block' : 'none' }}
                />
            ) : null}
            
            {(imageError || !preview_url || !imageLoaded) && (
                <img 
                    src={ThemeIcon} 
                    alt={displayName} 
                    className="preview"
                    style={{ display: imageError || !preview_url ? 'block' : (imageLoaded ? 'none' : 'block') }}
                />
            )}
        </div>
        <div className="store-card-footer">
            <div>
                <div className="store-card-footer-name">
                    {displayName}
                </div>
                <div className="store-card-footer-version">
                    {category || `Version ${version}`}
                </div>
            </div>

            <div className="d-flex">
                <Button size="large" onClick={() => {
                    setCurrentSchema(schema);
                    createTheme(schema, true);
                }}>
                    Add to library
                </Button>

                <div className={`more-buttons ${changelogs && changelogs.length ? '' : 'd-none'}`} ref={dropdownRef} onClick={toggleDropdownMenu}>

                    <Button variant="secondary" size="large" square className="ml-3">
                        <DotsIcon />
                    </Button>

                    <div className={`themes-buttons-dropdown customFadeIn ${buttonDropdown ? 'open' : ''}`}>
                        <Button variant="secondary" size="large" onClick={handleChangelogClick}>
                            <RenameIcon />
                            <span>Changelog</span>
                        </Button>
                    </div>
                </div>

            </div>
        </div>
    </div>
}

export default StoreCard;
